import dynamic from "next/dynamic";
import { BannerProps } from "components/base/Banner/Banner";
import { CalSaversCreditsCalculatorProps } from "components/base/CalSaversCreditCalculator";
import { Carousel1Props } from "components/base/Carousel1/Carousel1";
import { Carousel2Props } from "components/base/Carousel2/Carousel2";
import { Carousel3Props } from "components/base/Carousel3/Carousel3";
import { Carousel4Props } from "components/base/Carousel4/Carousel4";
import { Carousel5Props } from "components/base/Carousel5/Carousel5";
import { Carousel6Props } from "components/base/Carousel6/Carousel6";
import { Collage1Props } from "components/base/Collage1";
import { ComparisonChartProps } from "components/base/ComparisonChart/ComparisonChart";
import { Cta1Props } from "components/base/Cta1";
import { Cta10Props } from "components/base/Cta10";
import { Cta11Props } from "components/base/Cta11/Cta11";
import { Cta12Props } from "components/base/Cta12";
import { Cta15Props } from "components/base/Cta15";
import { Cta2Props } from "components/base/Cta2";
import { Cta3Props } from "components/base/Cta3";
import { Cta4Props } from "components/base/Cta4";
import { Cta5Props } from "components/base/Cta5";
import { Cta6Props } from "components/base/Cta6";
import { Cta7Props } from "components/base/Cta7";
import { Cta8Props } from "components/base/Cta8";
import { Cta9Props } from "components/base/Cta9";
import { DisclaimerCenterProps } from "components/base/DisclaimerCenter/DisclaimerCenter";
import { Disclosure2Props } from "components/base/Disclosure";
import { DisclosureNoIndexProps } from "components/base/DisclosureNoIndex";
import { DividerProps } from "components/base/Divider";
import { FAQProps } from "components/base/FAQ";
import { FAQContainedProps } from "components/base/FAQContained";
import { FAQSingleProps } from "components/base/FAQSingle";
import { Features1Props } from "components/base/Features1";
import { Features10Props } from "components/base/Features10";
import { Features11Props } from "components/base/Features11";
import { Features12Props } from "components/base/Features12";
import { Features14Props } from "components/base/Features14";
import { Features14AProps } from "components/base/Features14a";
import { Features15Props } from "components/base/Features15";
import { Features16Props } from "components/base/Features16";
import { Features17Props } from "components/base/Features17";
import { Features18Props } from "components/base/Features18";
import { Features19Props } from "components/base/Features19";
import { Features2Props } from "components/base/Features2";
import { Features20Props } from "components/base/Features20";
import { Features21Props } from "components/base/Features21";
import { Features22Props } from "components/base/Features22";
import { Features23Props } from "components/base/Features23/Features23";
import { Features24Props } from "components/base/Features24";
import { Features25Props } from "components/base/Features25/Features25";
import { Features26Props } from "components/base/Features26";
import { Features27Props } from "components/base/Features27/Features27";
import { Features28Props } from "components/base/Features28";
import { Features29Props } from "components/base/Features29";
import { Features3Props } from "components/base/Features3";
import { Features30Props } from "components/base/Features30";
import { Features32Props } from "components/base/Features32";
import { Features33Props } from "components/base/Features33";
import { Features34Props } from "components/base/Features34";
import { Features35Props } from "components/base/Features35";
import { Features36Props } from "components/base/Features36";
import { Features37Props } from "components/base/Features37";
import { Features4aProps } from "components/base/Features4a/Features4a";
import { Features5Props } from "components/base/Features5";
import { Features6Props } from "components/base/Features6";
import { Features6aProps } from "components/base/Features6a";
import { Features6bProps } from "components/base/Features6b";
import { Features7aProps } from "components/base/Features7a";
import { Features7bProps } from "components/base/Features7b";
import { Features8Props } from "components/base/Features8";
import { Features9Props } from "components/base/Features9";
import { Footer1Props } from "components/base/Footer/Footer";
import { Form1Props } from "components/base/Form1";
import { Header1Props } from "components/base/Header1/Header1";
import { Header2Props } from "components/base/Header2";
import { Header3Props } from "components/base/Header3";
import { Hero1Props } from "components/base/Hero1";
import { Hero10Props } from "components/base/Hero10";
import { Hero11Props } from "components/base/Hero11";
import { Hero12Props } from "components/base/Hero12";
import { Hero13Props } from "components/base/Hero13";
import { Hero14Props } from "components/base/Hero14";
import { Hero15Props } from "components/base/Hero15";
import { Hero16Props } from "components/base/Hero16";
import { Hero17Props } from "components/base/Hero17";
import { Hero18Props } from "components/base/Hero18";
import { Hero2Props } from "components/base/Hero2";
import { Hero2SubsectionProps } from "components/base/Hero2Subsection";
import { Hero3Props } from "components/base/Hero3";
import { Hero4Props } from "components/base/Hero4";
import { Hero5Props } from "components/base/Hero5";
import { Hero6Props } from "components/base/Hero6/Hero6";
import { Hero7Props } from "components/base/Hero7/Hero7";
import { Hero8Props } from "components/base/Hero8/Hero8";
import { Hero9Props } from "components/base/Hero9";
import { HeroSubsection1Props } from "components/base/HeroSubsection1";
import { HeroSubsection3Props } from "components/base/HeroSubsection3";
import { HeroSubsection4Props } from "components/base/HeroSubsection4";
import { HeroSubsection5Props } from "components/base/HeroSubsection5";
import { HeroSubsection6Props } from "components/base/HeroSubsection6";
import { IndicatorsPageProps } from "components/base/IndicatorsPage";
import { Introduction1Props } from "components/base/Introduction1/Introduction1";
import { Introduction2Props } from "components/base/Introduction2";
import { NotFoundProps } from "components/base/NotFound";
import { PortfoliosProps } from "components/base/Portfolios/Portfolios";
import { Pricing3Props } from "components/base/Pricing3";
import { Pricing4Props } from "components/base/Pricing4";
import { Pricing5Props } from "components/base/Pricing5/Pricing5";
import { SeoProps } from "components/base/Seo";
import { SpacingProps } from "components/base/Spacing";
import { StatePlanInfoProps } from "components/base/StatePlanInfo";
import { Stats1Props } from "components/base/Stats1";
import { Stats2Props } from "components/base/Stats2";
import { Stats3Props } from "components/base/Stats3";
import { Stats4Props } from "components/base/Stats4";
import { SuperHeaderProps } from "components/base/SuperHeader";
import { TableDatesProps } from "components/base/TableDates/TableDates";
import { TableFundsProps } from "components/base/TableFunds/TableFunds";
import { TableIraProps } from "components/base/TableIra";
import { TableOpenRolesProps } from "components/base/TableOpenRoles/TableOpenRoles";
import { TableSaversProps } from "components/base/TableSavers/TableSavers";
import { TaxCalculatorProps } from "components/base/TaxCalculator";
import { Title1Props } from "components/base/Title1";
import { Title10Props } from "components/base/Title10";
import { Title11Props } from "components/base/Title11";
import { Title12Props } from "components/base/Title12";
import { Title2Props } from "components/base/Title2";
import { Title3Props } from "components/base/Title3";
import { Title4Props } from "components/base/Title4";
import { Title5Props } from "components/base/Title5";
import { Title6Props } from "components/base/Title6";
import { Title7Props } from "components/base/Title7";
import { Title8Props } from "components/base/Title8";
import { Title9Props } from "components/base/Title9";
import { QuoteProps } from "components/Molecules/Quote/Quote";
import { StatsRowProps } from "components/Molecules/StatsRow";
import { HeroProps } from "components/Organisms/Hero";
import { IntroductionProps } from "components/Organisms/Introduction/Introduction";
import { MegaNavigationProps } from "components/Organisms/MegaNavigation";

const dynamicComponentList = {
  TaxCalculator: dynamic<TaxCalculatorProps>(() =>
    import("components/base/TaxCalculator").then(({ TaxCalculator }) => {
      return TaxCalculator;
    })
  ),
  CalSaversCreditsCalculator: dynamic<CalSaversCreditsCalculatorProps>(() =>
    import("components/base/CalSaversCreditCalculator").then(({ CalSaversCreditsCalculator }) => {
      return CalSaversCreditsCalculator;
    })
  ),
  Carousel1: dynamic<Carousel1Props>(() =>
    import("components/base/Carousel1/Carousel1").then(({ Carousel1 }) => {
      return Carousel1;
    })
  ),
  Carousel2: dynamic<Carousel2Props>(() =>
    import("components/base/Carousel2").then(({ Carousel2 }) => {
      return Carousel2;
    })
  ),
  Carousel3: dynamic<Carousel3Props>(() =>
    import("components/base/Carousel3/Carousel3").then(({ Carousel3 }) => {
      return Carousel3;
    })
  ),
  Carousel4: dynamic<Carousel4Props>(() =>
    import("components/base/Carousel4/Carousel4").then(({ Carousel4 }) => {
      return Carousel4;
    })
  ),
  Carousel5: dynamic<Carousel5Props>(() =>
    import("components/base/Carousel5").then(({ Carousel5 }) => {
      return Carousel5;
    })
  ),
  Carousel6: dynamic<Carousel6Props>(() =>
    import("components/base/Carousel6/Carousel6").then(({ Carousel6 }) => {
      return Carousel6;
    })
  ),
  Collage1: dynamic<Collage1Props>(() =>
    import("components/base/Collage1").then(({ Collage1 }) => {
      return Collage1;
    })
  ),
  Cta1: dynamic<Cta1Props>(() =>
    import("components/base/Cta1").then(({ Cta1 }) => {
      return Cta1;
    })
  ),
  Cta2: dynamic<Cta2Props>(() =>
    import("components/base/Cta2").then(({ Cta2 }) => {
      return Cta2;
    })
  ),
  Cta4: dynamic<Cta4Props>(() =>
    import("components/base/Cta4").then(({ Cta4 }) => {
      return Cta4;
    })
  ),
  Cta3: dynamic<Cta3Props>(() =>
    import("components/base/Cta3").then(({ Cta3 }) => {
      return Cta3;
    })
  ),
  Cta5: dynamic<Cta5Props>(() =>
    import("components/base/Cta5").then(({ Cta5 }) => {
      return Cta5;
    })
  ),
  Cta6: dynamic<Cta6Props>(() =>
    import("components/base/Cta6").then(({ Cta6 }) => {
      return Cta6;
    })
  ),
  Cta7: dynamic<Cta7Props>(() =>
    import("components/base/Cta7").then(({ Cta7 }) => {
      return Cta7;
    })
  ),
  Cta8: dynamic<Cta8Props>(() =>
    import("components/base/Cta8").then(({ Cta8 }) => {
      return Cta8;
    })
  ),
  Cta9: dynamic<Cta9Props>(() =>
    import("components/base/Cta9").then(({ Cta9 }) => {
      return Cta9;
    })
  ),
  Cta10: dynamic<Cta10Props>(() =>
    import("components/base/Cta10").then(({ Cta10 }) => {
      return Cta10;
    })
  ),
  Cta11: dynamic<Cta11Props>(() =>
    import("components/base/Cta11").then(({ Cta11 }) => {
      return Cta11;
    })
  ),
  Cta12: dynamic<Cta12Props>(() =>
    import("components/base/Cta12").then(({ Cta12 }) => {
      return Cta12;
    })
  ),
  Cta15: dynamic<Cta15Props>(() =>
    import("components/base/Cta15").then(({ Cta15 }) => {
      return Cta15;
    })
  ),
  CompChart: dynamic<ComparisonChartProps>(() =>
    import("components/base/ComparisonChart").then(({ ComparisonChart }) => {
      return ComparisonChart;
    })
  ),
  Disclosure: dynamic<Disclosure2Props>(() =>
    import("components/base/Disclosure").then(({ Disclosure }) => {
      return Disclosure;
    })
  ),
  Divider: dynamic<DividerProps>(() =>
    import("components/base/Divider").then(({ Divider }) => {
      return Divider;
    })
  ),
  IndicatorsPage: dynamic<IndicatorsPageProps>(() =>
    import("components/base/IndicatorsPage").then(({ IndicatorsPage }) => {
      return IndicatorsPage;
    })
  ),
  FAQ: dynamic<FAQProps>(() =>
    import("components/base/FAQ").then(({ FAQ }) => {
      return FAQ;
    })
  ),
  FAQContained: dynamic<FAQContainedProps>(() =>
    import("components/base/FAQContained").then(({ FAQContained }) => {
      return FAQContained;
    })
  ),
  FAQSingle: dynamic<FAQSingleProps>(() =>
    import("components/base/FAQSingle").then(({ FAQSingle }) => {
      return FAQSingle;
    })
  ),
  Features1: dynamic<Features1Props>(() =>
    import("components/base/Features1").then(({ Features1 }) => {
      return Features1;
    })
  ),
  Features2: dynamic<Features2Props>(() =>
    import("components/base/Features2").then(({ Features2 }) => {
      return Features2;
    })
  ),
  Features3: dynamic<Features3Props>(() =>
    import("components/base/Features3").then(({ Features3 }) => {
      return Features3;
    })
  ),
  Features4: dynamic<any>(() =>
    import("components/base/Features4").then(({ Features4 }) => {
      return Features4;
    })
  ),
  Features4a: dynamic<Features4aProps>(() =>
    import("components/base/Features4a").then(({ Features4a }) => {
      return Features4a;
    })
  ),
  Features5: dynamic<Features5Props>(() =>
    import("components/base/Features5").then(({ Features5 }) => {
      return Features5;
    })
  ),
  Features6: dynamic<Features6Props>(() =>
    import("components/base/Features6").then(({ Features6 }) => {
      return Features6;
    })
  ),
  Features6a: dynamic<Features6aProps>(() =>
    import("components/base/Features6a").then(({ Features6a }) => {
      return Features6a;
    })
  ),
  Features6b: dynamic<Features6bProps>(() =>
    import("components/base/Features6b").then(({ Features6B }) => {
      return Features6B;
    })
  ),
  Features7a: dynamic<Features7aProps>(() =>
    import("components/base/Features7a").then(({ Features7a }) => {
      return Features7a;
    })
  ),
  Features7B: dynamic<Features7bProps>(() =>
    import("components/base/Features7b").then(({ Features7b }) => {
      return Features7b;
    })
  ),
  Features8: dynamic<Features8Props>(() =>
    import("components/base/Features8").then(({ Features8 }) => {
      return Features8;
    })
  ),
  Features9: dynamic<Features9Props>(() =>
    import("components/base/Features9").then(({ Features9 }) => {
      return Features9;
    })
  ),
  Features10: dynamic<Features10Props>(() =>
    import("components/base/Features10").then(({ Features10 }) => {
      return Features10;
    })
  ),
  Features11: dynamic<Features11Props>(() =>
    import("components/base/Features11").then(({ Features11 }) => {
      return Features11;
    })
  ),
  Features12: dynamic<Features12Props>(() =>
    import("components/base/Features12").then(({ Features12 }) => {
      return Features12;
    })
  ),
  Features14: dynamic<Features14Props>(() =>
    import("components/base/Features14").then(({ Features14 }) => {
      return Features14;
    })
  ),
  Features14a: dynamic<Features14AProps>(() =>
    import("components/base/Features14a").then(({ Features14a }) => {
      return Features14a;
    })
  ),
  Features15: dynamic<Features15Props>(() =>
    import("components/base/Features15").then(({ Features15 }) => {
      return Features15;
    })
  ),
  Features16: dynamic<Features16Props>(() =>
    import("components/base/Features16").then(({ Features16 }) => {
      return Features16;
    })
  ),
  Features17: dynamic<Features17Props>(() =>
    import("components/base/Features17").then(({ Features17 }) => {
      return Features17;
    })
  ),
  Features18: dynamic<Features18Props>(() =>
    import("components/base/Features18").then(({ Features18 }) => {
      return Features18;
    })
  ),
  Features19: dynamic<Features19Props>(() =>
    import("components/base/Features19").then(({ Features19 }) => {
      return Features19;
    })
  ),
  Features20: dynamic<Features20Props>(() =>
    import("components/base/Features20").then(({ Features20 }) => {
      return Features20;
    })
  ),
  Features21: dynamic<Features21Props>(() =>
    import("components/base/Features21").then(({ Features21 }) => {
      return Features21;
    })
  ),
  Features22: dynamic<Features22Props>(() =>
    import("components/base/Features22").then(({ Features22 }) => {
      return Features22;
    })
  ),
  Features23: dynamic<Features23Props>(() =>
    import("components/base/Features23/Features23").then(({ Features23 }) => {
      return Features23;
    })
  ),
  Features24: dynamic<Features24Props>(() =>
    import("components/base/Features24").then(({ Features24 }) => {
      return Features24;
    })
  ),
  Features25: dynamic<Features25Props>(() =>
    import("components/base/Features25/Features25").then(({ Features25 }) => {
      return Features25;
    })
  ),
  Features26: dynamic<Features26Props>(() =>
    import("components/base/Features26").then(({ Features26 }) => {
      return Features26;
    })
  ),
  Features27: dynamic<Features27Props>(() =>
    import("components/base/Features27/Features27").then(({ Features27 }) => {
      return Features27;
    })
  ),
  Features28: dynamic<Features28Props>(() =>
    import("components/base/Features28").then(({ Features28 }) => {
      return Features28;
    })
  ),
  Features29: dynamic<Features29Props>(() =>
    import("components/base/Features29").then(({ Features29 }) => {
      return Features29;
    })
  ),
  Features30: dynamic<Features30Props>(() =>
    import("components/base/Features30").then(({ Features30 }) => {
      return Features30;
    })
  ),
  Features32: dynamic<Features32Props>(() =>
    import("components/base/Features32").then(({ Features32 }) => {
      return Features32;
    })
  ),
  Features33: dynamic<Features33Props>(() =>
    import("components/base/Features33").then(({ Features33 }) => {
      return Features33;
    })
  ),
  Features34: dynamic<Features34Props>(() =>
    import("components/base/Features34").then(({ Features34 }) => {
      return Features34;
    })
  ),
  Features35: dynamic<Features35Props>(() =>
    import("components/base/Features35").then(({ Features35 }) => {
      return Features35;
    })
  ),
  Features36: dynamic<Features36Props>(() =>
    import("components/base/Features36").then(({ Features36 }) => {
      return Features36;
    })
  ),
  Features37: dynamic<Features37Props>(() =>
    import("components/base/Features37").then(({ Features37 }) => {
      return Features37;
    })
  ),
  Footer1: dynamic<Footer1Props>(() =>
    import("components/base/Footer/Footer").then(({ Footer }) => {
      return Footer;
    })
  ),
  Form1: dynamic<Form1Props>(() =>
    import("components/base/Form1").then(({ Form1 }) => {
      return Form1;
    })
  ),
  MegaNavigation: dynamic<MegaNavigationProps>(() =>
    import("components/Organisms/MegaNavigation").then(({ MegaNavigation }) => {
      return MegaNavigation;
    })
  ),
  Header1: dynamic<Header1Props>(() =>
    import("components/base/Header1").then(({ Header1 }) => {
      return Header1;
    })
  ),
  Header2: dynamic<Header2Props>(() =>
    import("components/base/Header2").then(({ Header2 }) => {
      return Header2;
    })
  ),
  Header3: dynamic<Header3Props>(() =>
    import("components/base/Header3").then(({ Header3 }) => {
      return Header3;
    })
  ),
  Hero: dynamic<HeroProps>(() =>
    import("components/Organisms/Hero").then(({ Hero }) => {
      return Hero;
    })
  ),
  Hero1: dynamic<Hero1Props>(() =>
    import("components/base/Hero1").then(({ Hero1 }) => {
      return Hero1;
    })
  ),
  Hero2: dynamic<Hero2Props>(() =>
    import("components/base/Hero2").then(({ Hero2 }) => {
      return Hero2;
    })
  ),
  Hero3: dynamic<Hero3Props>(() =>
    import("components/base/Hero3").then(({ Hero3 }) => {
      return Hero3;
    })
  ),
  Hero4: dynamic<Hero4Props>(() =>
    import("components/base/Hero4").then(({ Hero4 }) => {
      return Hero4;
    })
  ),
  Hero5: dynamic<Hero5Props>(() =>
    import("components/base/Hero5").then(({ Hero5 }) => {
      return Hero5;
    })
  ),
  Hero6: dynamic<Hero6Props>(() =>
    import("components/base/Hero6/Hero6").then(({ Hero6 }) => {
      return Hero6;
    })
  ),
  Hero7: dynamic<Hero7Props>(() =>
    import("components/base/Hero7/Hero7").then(({ Hero7 }) => {
      return Hero7;
    })
  ),
  Hero8: dynamic<Hero8Props>(() =>
    import("components/base/Hero8/Hero8").then(({ Hero8 }) => {
      return Hero8;
    })
  ),
  Hero9: dynamic<Hero9Props>(() =>
    import("components/base/Hero9").then(({ Hero9 }) => {
      return Hero9;
    })
  ),
  Hero11: dynamic<Hero11Props>(() =>
    import("components/base/Hero11").then(({ Hero11 }) => {
      return Hero11;
    })
  ),
  Hero10: dynamic<Hero10Props>(() =>
    import("components/base/Hero10").then(({ Hero10 }) => {
      return Hero10;
    })
  ),
  Hero12: dynamic<Hero12Props>(() =>
    import("components/base/Hero12").then(({ Hero12 }) => {
      return Hero12;
    })
  ),
  Hero13: dynamic<Hero13Props>(() =>
    import("components/base/Hero13").then(({ Hero13 }) => {
      return Hero13;
    })
  ),
  Hero14: dynamic<Hero14Props>(() =>
    import("components/base/Hero14").then(({ Hero14 }) => {
      return Hero14;
    })
  ),
  Hero15: dynamic<Hero15Props>(() =>
    import("components/base/Hero15").then(({ Hero15 }) => {
      return Hero15;
    })
  ),
  Hero16: dynamic<Hero16Props>(() =>
    import("components/base/Hero16").then(({ Hero16 }) => {
      return Hero16;
    })
  ),
  Hero17: dynamic<Hero17Props>(() =>
    import("components/base/Hero17").then(({ Hero17 }) => {
      return Hero17;
    })
  ),
  Hero18: dynamic<Hero18Props>(() =>
    import("components/base/Hero18").then(({ Hero18 }) => {
      return Hero18;
    })
  ),
  Seo: dynamic<SeoProps>(() =>
    import("components/base/Seo").then(({ Seo }) => {
      return Seo;
    })
  ),
  HeroSubsection1: dynamic<HeroSubsection1Props>(() =>
    import("components/base/HeroSubsection1").then(({ HeroSubsection1 }) => {
      return HeroSubsection1;
    })
  ),
  Hero2Subsection: dynamic<Hero2SubsectionProps>(() =>
    import("components/base/Hero2Subsection").then(({ Hero2Subsection }) => {
      return Hero2Subsection;
    })
  ),
  HeroSubsection3: dynamic<HeroSubsection3Props>(() =>
    import("components/base/HeroSubsection3").then(({ HeroSubsection3 }) => {
      return HeroSubsection3;
    })
  ),
  HeroSubsection4: dynamic<HeroSubsection4Props>(() =>
    import("components/base/HeroSubsection4").then(({ HeroSubsection4 }) => {
      return HeroSubsection4;
    })
  ),
  HeroSubsection5: dynamic<HeroSubsection5Props>(() =>
    import("components/base/HeroSubsection5").then(({ HeroSubsection5 }) => {
      return HeroSubsection5;
    })
  ),
  HeroSubsection6: dynamic<HeroSubsection6Props>(() =>
    import("components/base/HeroSubsection6").then(({ HeroSubsection6 }) => {
      return HeroSubsection6;
    })
  ),
  Introduction1: dynamic<Introduction1Props>(() =>
    import("components/base/Introduction1").then(({ Introduction1 }) => {
      return Introduction1;
    })
  ),
  Introduction2: dynamic<Introduction2Props>(() =>
    import("components/base/Introduction2").then(({ Introduction2 }) => {
      return Introduction2;
    })
  ),
  NotFound: dynamic<NotFoundProps>(() =>
    import("components/base/NotFound").then(({ NotFound }) => {
      return NotFound;
    })
  ),
  Portfolios: dynamic<PortfoliosProps>(() =>
    import("components/base/Portfolios").then(({ Portfolios }) => {
      return Portfolios;
    })
  ),
  Pricing4: dynamic<Pricing4Props>(() =>
    import("components/base/Pricing4").then(({ Pricing4 }) => {
      return Pricing4;
    })
  ),
  Pricing3: dynamic<Pricing3Props>(() =>
    import("components/base/Pricing3").then(({ Pricing3 }) => {
      return Pricing3;
    })
  ),
  Pricing5: dynamic<Pricing5Props>(() =>
    import("components/base/Pricing5").then(({ Pricing5 }) => {
      return Pricing5;
    })
  ),
  Spacing: dynamic<SpacingProps>(() =>
    import("components/base/Spacing").then(({ Spacing }) => {
      return Spacing;
    })
  ),
  StatePlanInfo: dynamic<StatePlanInfoProps>(() =>
    import("components/base/StatePlanInfo").then(({ StatePlanInfo }) => {
      return StatePlanInfo;
    })
  ),
  Stats1: dynamic<Stats1Props>(() =>
    import("components/base/Stats1").then(({ Stats1 }) => {
      return Stats1;
    })
  ),
  Stats4: dynamic<Stats4Props>(() =>
    import("components/base/Stats4").then(({ Stats4 }) => {
      return Stats4;
    })
  ),
  StatsRow: dynamic<StatsRowProps>(() =>
    import("components/Molecules/StatsRow").then(({ StatsRow }) => {
      return StatsRow;
    })
  ),
  Stats2: dynamic<Stats2Props>(() =>
    import("components/base/Stats2").then(({ Stats2 }) => {
      return Stats2;
    })
  ),
  Stats3: dynamic<Stats3Props>(() =>
    import("components/base/Stats3").then(({ Stats3 }) => {
      return Stats3;
    })
  ),
  SuperHeader: dynamic<SuperHeaderProps>(() =>
    import("components/base/SuperHeader").then(({ SuperHeader }) => {
      return SuperHeader;
    })
  ),
  TableOpenRoles: dynamic<TableOpenRolesProps>(() =>
    import("components/base/TableOpenRoles").then(({ TableOpenRoles }) => {
      return TableOpenRoles;
    })
  ),
  TableDates: dynamic<TableDatesProps>(() =>
    import("components/base/TableDates/TableDates").then(({ TableDates }) => {
      return TableDates;
    })
  ),
  TableIra: dynamic<TableIraProps>(() =>
    import("components/base/TableIra").then(({ TableIra }) => {
      return TableIra;
    })
  ),
  TableFunds: dynamic<TableFundsProps>(() =>
    import("components/base/TableFunds/TableFunds").then(({ TableFunds }) => {
      return TableFunds;
    })
  ),
  TableSavers: dynamic<TableSaversProps>(() =>
    import("components/base/TableSavers/TableSavers").then(({ TableSavers }) => {
      return TableSavers;
    })
  ),
  Title1: dynamic<Title1Props>(() =>
    import("components/base/Title1").then(({ Title1 }) => {
      return Title1;
    })
  ),
  Title2: dynamic<Title2Props>(() =>
    import("components/base/Title2").then(({ Title2 }) => {
      return Title2;
    })
  ),
  Title3: dynamic<Title3Props>(() =>
    import("components/base/Title3").then(({ Title3 }) => {
      return Title3;
    })
  ),
  Title4: dynamic<Title4Props>(() =>
    import("components/base/Title4").then(({ Title4 }) => {
      return Title4;
    })
  ),
  Title6: dynamic<Title6Props>(() =>
    import("components/base/Title6").then(({ Title6 }) => {
      return Title6;
    })
  ),
  Title5: dynamic<Title5Props>(() =>
    import("components/base/Title5").then(({ Title5 }) => {
      return Title5;
    })
  ),
  Title7: dynamic<Title7Props>(() =>
    import("components/base/Title7").then(({ Title7 }) => {
      return Title7;
    })
  ),
  Title8: dynamic<Title8Props>(() =>
    import("components/base/Title8").then(({ Title8 }) => {
      return Title8;
    })
  ),
  Title9: dynamic<Title9Props>(() =>
    import("components/base/Title9").then(({ Title9 }) => {
      return Title9;
    })
  ),
  Title10: dynamic<Title10Props>(() =>
    import("components/base/Title10").then(({ Title10 }) => {
      return Title10;
    })
  ),
  Title11: dynamic<Title11Props>(() =>
    import("components/base/Title11").then(({ Title11 }) => {
      return Title11;
    })
  ),
  Title12: dynamic<Title12Props>(() =>
    import("components/base/Title12").then(({ Title12 }) => {
      return Title12;
    })
  ),
  Quote: dynamic<QuoteProps>(() =>
    import("components/Molecules/Quote/Quote").then(({ Quote }) => {
      return Quote;
    })
  ),
  Introduction: dynamic<IntroductionProps>(() =>
    import("components/Organisms/Introduction/Introduction").then(({ Introduction }) => {
      return Introduction;
    })
  ),
  Banner: dynamic<BannerProps>(
    () =>
      import("components/base/Banner/Banner").then(({ Banner }) => {
        return Banner;
      }),
    { ssr: false }
  ),
  DisclaimerCenter: dynamic<DisclaimerCenterProps>(() =>
    import("components/base/DisclaimerCenter").then(({ DisclaimerCenter }) => {
      return DisclaimerCenter;
    })
  ),
  DisclosureNoIndex: dynamic<DisclosureNoIndexProps>(() =>
    import("components/base/DisclosureNoIndex").then(({ DisclosureNoIndex }) => {
      return DisclosureNoIndex;
    })
  ),
};

type DynamicComponentList = typeof dynamicComponentList;

export { dynamicComponentList };
export type { DynamicComponentList };
